import { Zap, Eye, BadgeCheck, Briefcase } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";

const ITEMS = [
    { Icon: Zap, key: "a", testId: "why-fast" },
    { Icon: Eye, key: "b", testId: "why-transparent" },
    { Icon: BadgeCheck, key: "c", testId: "why-approval" },
    { Icon: Briefcase, key: "d", testId: "why-doorstep" },
];

const WhyChooseUs = () => {
    const { lang, t } = useLanguage();
    const gu = lang === "gu" ? "font-gujarati" : "";

    return (
        <section
            data-testid="why-section"
            className="py-24 md:py-32 bg-[#0B308A] text-white relative overflow-hidden"
        >
            {/* Decorative pattern */}
            <div className="absolute inset-0 opacity-[0.07] pointer-events-none">
                <div
                    className="w-full h-full"
                    style={{
                        backgroundImage:
                            "radial-gradient(circle at 1px 1px, white 1px, transparent 0)",
                        backgroundSize: "32px 32px",
                    }}
                />
            </div>
            <div className="absolute -top-32 -right-32 w-96 h-96 bg-[#FACC15]/20 rounded-full blur-3xl pointer-events-none" />
            <div className="absolute -bottom-40 -left-32 w-96 h-96 bg-white/5 rounded-full blur-3xl pointer-events-none" />

            <div className="relative max-w-7xl mx-auto px-6 md:px-10">
                <div className="max-w-3xl">
                    <span
                        className={`inline-block text-[11px] uppercase tracking-[0.22em] font-semibold text-[#FACC15] ${gu}`}
                    >
                        {t("why.overline")}
                    </span>
                    <h2
                        className={`mt-4 text-3xl sm:text-4xl lg:text-5xl font-display font-bold text-white leading-[1.1] ${gu}`}
                    >
                        {t("why.title")}
                    </h2>
                </div>

                <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
                    {ITEMS.map(({ Icon, key, testId }) => (
                        <div
                            key={key}
                            data-testid={testId}
                            className="group border border-white/10 hover:border-[#FACC15]/60 p-7 transition-all duration-300 backdrop-blur-sm bg-white/[0.03] hover:bg-white/[0.06]"
                        >
                            <div className="w-12 h-12 rounded-sm bg-white/10 text-[#FACC15] flex items-center justify-center group-hover:bg-[#FACC15] group-hover:text-[#0B308A] transition-colors">
                                <Icon className="w-6 h-6" strokeWidth={2} />
                            </div>
                            <h3
                                className={`mt-6 font-display font-semibold text-xl text-white ${gu}`}
                            >
                                {t(`why.items.${key}_title`)}
                            </h3>
                            <p
                                className={`mt-3 text-[14.5px] text-white/70 leading-relaxed ${gu}`}
                            >
                                {t(`why.items.${key}_desc`)}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default WhyChooseUs;
